// assets
import { IconBrandChrome, IconFileDots, IconHelp, IconSitemap } from '@tabler/icons';

// constant
const icons = {
    IconBrandChrome: IconBrandChrome,
    IconHelp: IconHelp,
    IconSitemap: IconSitemap,
    IconFileDots: IconFileDots
};

//-----------------------|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||-----------------------//

export const other = {
    id: 'sample-docs-roadmap',
    type: 'group',
    children: [
        // {
        //     id: 'sample-page',
        //     title: 'Sample Page',
        //     type: 'item',
        //     url: '/sample-page',
        //     icon: icons['IconBrandChrome'],
        //     breadcrumbs: false
        // },
        {
            id: 'util-docs',
            title: 'Documentação',
            type: 'item',
            url: '/dashboard/docs/welcome',
            icon: icons['IconFileDots'],
            external: false,
            target: false
        },
        {
            id: 'documentation',
            title: 'Documentação Online',
            type: 'item',
            url: 'https://docs.loged.com.br',
            icon: icons['IconHelp'],
            external: true,
            target: true
        }
    ]
};
